
const PURCHASE_DISH: 0 = 0
const PURCHASE_COMPLEX: 1 = 1

export const purchaseTypes = {
  PURCHASE_DISH,
  PURCHASE_COMPLEX,
}

export type Purchase = {
  id: number,
  type: typeof purchaseTypes[keyof typeof purchaseTypes],
  title: string,
  cost: number,
  count: number,
  total: number,
}

export const dateFormat = 'YYYY-MM-DD' as const

export type ReportsDataOrderPurchasesResult = {
  from: string
  to: string
  purchases: Array<Purchase>
  groups: Record<string, Array<{ title: string, count: number }>>
}
